import { render } from "./TaskGeneric.vue?vue&type=template&id=6e3c3d6f"
import script from "./TaskGeneric.vue?vue&type=script&lang=js"
export * from "./TaskGeneric.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__